export default __webpack_public_path__ + "static/samsung-c2a142f26ed35467faffb20fa5c6e750.jpg";